import React from 'react';
import { NexsetStats } from 'new/elements/NexsetStats';

interface StatsTabProps {
  dataset: {
    id: number;
    [key: string]: any;
  };
}

export const StatsTab = ({ dataset }: StatsTabProps) => {
  return <NexsetStats resourceId={String(dataset.id)} />;
};
